import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=0cd230bb&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=0cd230bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd230bb",
  null
  
)

export default component.exports